
import { types, actions } from './requests'
export const DELETEPICTURE_TYPES = {
    ...types('DELETEPICTURE'),
}
export const DELETEPICTURE_ACTIONS = {
    ...actions('DELETEPICTURE'),
}